export const accountTaskIdentityKey = (viewMode: string, userId: string) =>
  `${viewMode}:account:${userId}`;
